export default {
  navigationBarTitleText: '验收报告'
};